import { render, staticRenderFns } from "./metrics-skeleton.vue?vue&type=template&id=a2a78c86&scoped=true"
import script from "./metrics-skeleton.vue?vue&type=script&lang=js"
export * from "./metrics-skeleton.vue?vue&type=script&lang=js"
import style0 from "./metrics-skeleton.vue?vue&type=style&index=0&id=a2a78c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a78c86",
  null
  
)

export default component.exports